<template>
  <layout-register :step="step" :title-step="$t('m153')">
    <template #description-page>
      {{ $t('m149', { awto: $store.getters['visualResources/appName'] }) }}
    </template>
    <div class="row">
      <div class="col-md-6 col-12">
        <a-toc-container
          icon="ic-camera"
          :background="
            documentTypeId == 'CHL1' ? 'chi-1-front' : 'ci-front-chl'
          "
          :label="$t('m154')"
          containerId="front"
          :img="form.photoFront.value"
          :error="
            form.photoFront.error.length > 0 || form.idFront.error.length > 0
          "
          :errorMessage="
            form.photoFront.error ? form.photoFront.error : form.idFront.error
          "
          @actuated="goesTo('front')"
        />
      </div>
      <div class="col-md-6 col-12">
        <a-toc-container
          icon="ic-camera"
          :background="documentTypeId == 'CHL1' ? 'chi-1-back' : 'ci-back-chl'"
          :label="$t('m150')"
          containerId="back"
          :img="form.photoBack.value"
          :error="
            form.photoBack.error.length > 0 || form.idBack.error.length > 0
          "
          :errorMessage="
            form.photoBack.error ? form.photoBack.error : form.idBack.error
          "
          @actuated="goesTo('back')"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-10 mx-auto">
        <p class="mb-4 md-text-center">
          {{ $t('m151') }}
          <a role="button" tabindex="0" @click="modal = true">
            {{ $t('m152') }}
          </a>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-xs-12 col-sm-12 col-12 with-go-back">
        <div @click="goBack" class="go-back">
          <img src="../assets/icons/nav-blue-ic-arrow-left.png" />
          <span>
            {{ $t('m40') }}
          </span>
        </div>
        <a-btn
          class="next-step-button"
          primary
          @click="sendDocuments"
          :loading="loadingBtn"
        >
          {{ $t('m15') + ' 5' }}
        </a-btn>
      </div>
    </div>

    <a-modal-toc-auto-captura :modal="modal" @close="modal = false" />
    <a-modal class="modal-md" v-if="tocModal" @close="tocModal = false">
      <div slot="body">
        <div id="toc-container"></div>
      </div>
      <div slot="footer"></div>
    </a-modal>
  </layout-register>
</template>

<script>
import { validator } from '@/mixins/validator.js';
import { toc } from '@/mixins/toc.js';
import { imageConverter } from '@/mixins/imageConverter.js';
import ATocContainer from '@/components/ui/ATocContainer';
import AModal from '@/components/ui/AModal';
import AModalTocAutoCaptura from '@/components/modals/AModalTocAutoCaptura';
import ABtn from '@/components/ui/ABtn';
export default {
  components: {
    ATocContainer,
    AModalTocAutoCaptura,
    AModal,
    ABtn,
  },
  mixins: [toc, imageConverter, validator],
  data() {
    return {
      modal: false,
      step: 4,
      loadingBtn: false,
      titlePage: this.$t('m180'),
    };
  },
  methods: {
    async sendDocuments() {
      if (this.validateForm()) {
        let photoFrontBlob = await this.srcToBlob(
          this.form.photoFront.value,
          'image/jpeg',
          0.1,
        );
        let photoBackBlob = await this.srcToBlob(
          this.form.photoBack.value,
          'image/jpeg',
          0.1,
        );
        const formData = new FormData();
        formData.append('fileFront', photoFrontBlob);
        formData.append('fileBack', photoBackBlob);
        formData.append('idFront', this.form.idFront.value);
        formData.append('idBack', this.form.idBack.value);

        this.loadingBtn = true;
        this.$store.dispatch('register/tocId', formData).then(resp => {
          this.loadingBtn = false;
          if (resp.registrationStep) {
            this.$router.push({ name: resp.registrationStep });
          }
        });
      }
    },
    goBack() {
      this.$store.dispatch('register/setRegistrationStep', 'DOCUMENT');
      setTimeout(() => {
        this.$router.push({ name: 'DOCUMENT' });
      }, 100);
    },
  },
  mounted() {
    this.form.photoFront.rules = [this.rules.required];
    this.form.photoBack.rules = [this.rules.required];
    this.form.idFront.rules = [this.rules.required];
    this.form.idBack.rules = [this.rules.required];
    let documentTypeId = this.$store.getters['register/documentTypeId'];
    if (!documentTypeId) {
      this.$store.dispatch('register/profile').then(() => {
        this.documentTypeId =
          this.$store.getters['register/documentTypeId'] === 1
            ? 'CHL1'
            : 'CHL2';
      });
    } else {
      this.documentTypeId = documentTypeId === 1 ? 'CHL1' : 'CHL2';
    }
  },
};
</script>
